import { type ReactNode } from 'react';

interface KpiCardProps {
  label:    string;
  value:    ReactNode;
  unit?:    string;
  icon?:    ReactNode;
  /** Variante de la barre top : default = primary, ok = vert, warn = jaune, alert = rouge */
  type?:    'default' | 'ok' | 'warn' | 'alert';
  /** Tendance affichée en bas (↑ 12% vs avril, etc.) */
  trend?:   { label: string; direction: 'up' | 'down' | 'flat' };
  /** Background customisé de l'icône (sinon var(--p-soft) par défaut) */
  iconBg?:  string;
  /** Ligne secondaire sous la valeur (ex. cumul annuel). */
  sub?:     ReactNode;
}

/**
 * KpiCard pixel-perfect CTO-FRONT-002 (.ds-kc).
 * Référence : design-dashboard-finance-v1.html lignes 681-711.
 */
export const KpiCard = ({ label, value, unit, icon, type = 'default', trend, iconBg, sub }: KpiCardProps) => {
  const typeClass =
    type === 'ok'    ? ' kc-ok'    :
    type === 'warn'  ? ' kc-warn'  :
    type === 'alert' ? ' kc-alert' : '';

  const trendClass =
    trend?.direction === 'up'   ? 'ds-trend-up'   :
    trend?.direction === 'down' ? 'ds-trend-down' : 'ds-trend-flat';

  const arrow =
    trend?.direction === 'up'   ? '↑' :
    trend?.direction === 'down' ? '↓' : '=';

  return (
    <div className={`ds-kc${typeClass}`}>
      {icon && (
        <div className="ds-kc-ico" style={iconBg ? { background: iconBg } : undefined}>
          {icon}
        </div>
      )}
      <div className="ds-kc-label">{label}</div>
      <div className="ds-kc-value">
        {value}
        {unit && <> <span className="ds-kc-unit">{unit}</span></>}
      </div>
      {sub && <div className="ds-kc-sub">{sub}</div>}
      {trend && (
        <div className={`ds-kc-trend ${trendClass}`}>
          {arrow} {trend.label}
        </div>
      )}
    </div>
  );
};
